




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import EditCard from '@/components/EditCard.vue';

@Component({
  name: 'TaskCard',
  components: { EditCard },
})

export default class TaskCard extends Vue {
  @Prop({ type: Object, required: true }) public taskCard!: {};
  public isEditCard: boolean = false;

  public deleteCard(): void {
    this.$emit('deleteCard');
  }

  public checkDate(date: string): void | boolean {
    const cardDate = new Date(date);
    const currentDate = new Date((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10));

    return cardDate < currentDate;
  }

  public editCard(): void {
    this.isEditCard = true;
  }

  public setCardToArchive(): void {
    this.$emit('setCardToArchive');
  }
}

